module.exports = __webpack_public_path__ + "static/media/sort-up.09cd39d9.svg";